<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center right-[20px] left-[20px] dismissWrraper">
    <div class="bg-white rounded-xl shadow-xl w-full mx-4 max-h-[90vh] overflow-y-auto p-4 flex flex-col gap-3 dismissInnerWrapper">
      <!-- Modal Header -->
      <div class="sticky top-0 bg-white p-4 border-b border-gray-200 flex justify-between items-center">
        <h3 class="text-lg font-bold text-gray-800">
          رفض الطلب
        </h3>
        <button 
          class="closeButton"
          @click="emit('close')"
        >
          <img
            src="@/assets/min/cancel.svg"
            class="cursor-pointer"
          >
        </button>
      </div>
      
      <!-- Modal Content -->
      <div class="p-6 space-y-6 overflow-y-auto">
        <!-- Reasons Section -->
        <div class="mb-4">
          <h4 class="font-bold text-gray-700 mb-4 text-right">
            أسباب الرفض
          </h4>
          <ul class="space-y-3 flex flex-col gap-3">
            <li
              v-for="(reason, index) in reasons"
              :key="reason.id"
              class="flex items-center justify-between p-4 border border-gray-200 rounded-xl hover:bg-gray-50 transition-colors"
              @click="dissmissalReason = reason.id"
            >
              <label
                :for="'reason' + index"
                class="flex-1 text-right cursor-pointer"
              >
                {{ reason.reason_name }}
              </label>
              <input
                :id="'reason' + index"
                v-model="dissmissalReason"
                type="radio"
                class="h-5 w-5 text-green-500 focus:ring-green-500 border-gray-300"
                :value="reason.id"
              >
            </li>
          </ul>
        </div>

        <!-- Alternatives Section -->
        <div
          v-if="options.length > 0"
          class="mb-4"
        >
          <h4 class="font-bold text-gray-700 mb-4 text-right">
            بدائل مقترحة
          </h4>
          <ul class="space-y-3 flex flex-col gap-3">
            <li
              v-for="(option, index) in options"
              :key="option.id"
              class="flex items-center justify-between p-4 border border-gray-200 rounded-xl hover:bg-gray-50 transition-colors"
            >
              <label
                :for="'option' + index"
                class="flex-1 text-right cursor-pointer"
              >
                {{ option.name }} {{ option.price }} ج.م - المتوفر {{ option.quantity }} {{ option.unit }}
              </label>
              <input
                :id="'option' + index"
                v-model="alternativeOptions"
                type="checkbox"
                class="h-5 w-5 text-green-500 focus:ring-green-500 border-gray-300 rounded"
                :value="option.sku"
              >
            </li>
          </ul>
        </div>

        <!-- Alternative Product Code -->
        <div class="mb-4">
          <h4 class="font-bold text-gray-700 mb-4 text-right">
            إضافة كود بديل
          </h4>
          <input
            v-model="altProductCode"
            type="text"
            class="w-full p-3 border border-gray-300 rounded-xl focus:ring-green-500 focus:border-green-500 px-2 py-3"
            placeholder="ادخل كود المنتج البديل"
          >
        </div>

        <!-- Comment Section -->
        <div class="mb-4">
          <h4 class="font-bold text-gray-700 mb-4 text-right">
            التعليق
          </h4>
          <textarea
            v-model="comment"
            class="w-full p-3 border border-gray-300 rounded-xl focus:ring-green-500 focus:border-green-500 h-32 px-2 py-1"
            placeholder="أضف تعليقك هنا..."
          />
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="sticky bottom-0 bg-white p-4 border-t border-gray-200 flex justify-end space-x-3 gap-4">
        <button
          class="px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-600 transition-colors opacity-90 submitButton"
          :disabled="isSubmitDisabled"
          :class="{'opacity-50 cursor-not-allowed': !dissmissalReason}"
          @click="submit"
        >
          تأكيد الرفض
        </button>
        <button
          class="px-4 py-2 border border-gray-300 rounded-xl text-gray-700 hover:bg-gray-50 transition-colors closeButton"
          @click="emit('close')"
        >
          إلغاء
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  reasons: {
    type: Array,
    required: true,
    default: () => []
  },
  options: {
    type: Array,
    required: true,
    default: () => []
  }
});

const emit = defineEmits(['submit', 'close']);

const dissmissalReason = ref('');
const alternativeOptions = ref([]);
const altProductCode = ref('');
const comment = ref('');

const submit = () => {
  emit('submit', {
    reason: dissmissalReason.value,
    alternatives: alternativeOptions.value,
    altProductCode: altProductCode.value,
    comment: comment.value,
    reasonName: props.reasons?.find(r => r.id === dissmissalReason.value)?.reason_name || '',
    optionsNames: props.options.length ? props.options?.filter(o => alternativeOptions.value.includes(o.sku)).map(o => o.name) : []
  });
};
const isSubmitDisabled = computed(() => {
  if (!dissmissalReason.value) return true;
  
  if (props.options.length > 0 && alternativeOptions.value.length === 0) return true;
  if (props.options.message && !altProductCode.value.trim()) return true;
  
  return false;
});
</script>

<style scoped>
.dismissWrraper {
  z-index: 1000;
  right: 20%;
  top:10%;
  left: 20%;
}
.dismissInnerWrapper {
  max-height: 80vh;
  overflow-y: auto;
}
.submitButton {
  background-color: #84c559;
}
.closeButton {
  background: none;
  border: none;
  cursor: pointer;
}
input[type="radio"],
input[type="checkbox"] {
  cursor: pointer;
  width: 20px;
  height: 20px;
  accent-color: #84c559;
  color: white
}
</style>